import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/plan/update/license.plan.featureGroups.set.mutation.gql"
import type {
  LicensePlanFeatureGroupsSetMutation,
  LicensePlanFeatureGroupsSetMutationVariables,
} from "@/v2-backoffice-client/license/plan/update/__types__/license.plan.featureGroups.set.mutation"

type Options = MutationHookOptions<
  LicensePlanFeatureGroupsSetMutation,
  LicensePlanFeatureGroupsSetMutationVariables
>

export function useLicensePlanFeatureGroupsSetMutation(options?: Options) {
  return useMutation<
    LicensePlanFeatureGroupsSetMutation,
    LicensePlanFeatureGroupsSetMutationVariables
  >(mutation, options)
}
